/*global google*/

import React, { Component } from 'react'
import GoogleMapReact from 'google-map-react';
import ReactTable from "react-table";
import { Modal, Button} from 'react-bootstrap';
import './bootstrap.min.css';
import AddSiteForm from './AddSiteForm'
import AddTransmitterForm from './AddTransmitterForm'
import TransmitterTable from './txfreqtable/table'
import axios from 'axios'

import blacktowericon from './blacktower.png'
import redtowericon from './redtower.png'

const https = require('https');

class TransmittingStations extends Component {
  constructor(props) {
    super(props)
    this.markers={}
    this.exclusivelyExpandedRow=null
    this.state = {
        showAddTransmitterModal: false,
        antenna_options: {},
        default_center:{
            lat: 59.0084,
            lng: -3.1214,
            },
        expanded: {},
        stations:[],
        map: null
    }

    this.submitAddStation = this.submitAddStation.bind(this)
    this.sortBy = this.sortBy.bind(this)
  }

  componentDidMount() {
    if (this.props.getPageState("TransmittingStations")){
      this.setState(this.props.getPageState("TransmittingStations"))
    }

    let URL = `${this.props.SERVER_URLS.api}/antenna_options?lo=${this.props.allPageStates.MapSelection.selected_freqs[0]}&hi=${this.props.allPageStates.MapSelection.selected_freqs[1]}`
    axios.get(URL)
    .then(response => {
      if(response.data) { //has previous request
        this.setState({
            antenna_options: response.data
        })
      }
    })
    .catch(error => {
        console.log(error)
    })
  }

  modifyState = (state) => {
    this.setState(state)
    this.props.updatePageState("TransmittingStations", state)
  }

  compareBy = (key) => {
    return function(a, b) {
      if (a[key] < b[key]) return -1;
      if (a[key] > b[key]) return 1;
      return 0;
    };
  };

  sortBy = (siteIndex,key) => {
    let stationsCopy = this.state.stations
    stationsCopy[siteIndex].sectors.sort(this.compareBy(key));
    this.modifyState({stations: stationsCopy});
  };

  removeTransmitter = (rowId, siteIndex) => {
    // Array.prototype.filter returns new array
    // so we aren't mutating state here
    let stationsCopy = this.state.stations
    stationsCopy[siteIndex].sectors = stationsCopy[siteIndex].sectors.filter((row) => row.id !== rowId);
    this.modifyState({stations: stationsCopy});
  };

  editTransmitter = (siteIndex, transmitterIndex) => {
    console.log(siteIndex, transmitterIndex);
    this.currentTowerIndex = siteIndex;
    this.currentTransmitterIndex = transmitterIndex;
    this.setState({showAddTransmitterModal: true})
  }

  addTransmitterFormInitialValues = () => {
    if (this.state.stations[this.currentTowerIndex].sectors.length === 0 || this.currentTransmitterIndex === this.state.stations[this.currentTowerIndex].sectors.length) {
      // add
      return {
        elevation_m_AGL: 10,
        azimuth: 0,
        eirp_dbw: 5,
        peak: 14,
        tilt: 0,
        antenna: null
      };
    } else {
    // edit
      const currentTransmitter = this.state.stations[this.currentTowerIndex].sectors[this.currentTransmitterIndex];
      return {
        elevation_m_AGL: currentTransmitter.elevation_m_AGL,
        azimuth: currentTransmitter.azimuth,
        eirp_dbw: currentTransmitter.eirp_dbw,
        peak: currentTransmitter.peak,
        tilt: currentTransmitter.tilt,
        antenna: currentTransmitter.antenna
      }
    }
  }

  submitAddStation(values, stationIndex) {
    let s = this.state.stations
    s[stationIndex] = {
      "lat": values.latitude,
      "long": values.longitude,
      "eastings": values.eastings,
      "northings": values.northings,
      "britgrid": values.britgrid,
      "address": values.address,
      "address_components": values.address_components,
      "sectors": values.sectors
    };

    this.highlightMarker(stationIndex, values.latitude,values.longitude)
    this.modifyState({ stations: s, default_center:{lat:values.latitude, lng: values.longitude}})
  }

  onExpandedChange(newExpanded) {
    this.setState({
      expanded: newExpanded
    });
  }

  configureMap = ({ map, maps }) => {
    this.setState({"map": map});
    map.setMapTypeId('hybrid');

    this.placeMarker = (index, lat, long) =>{
      let point = new google.maps.Marker({
        position: {
          lat: lat,
          lng: long,
          },
        map,
        icon: blacktowericon,
      });
      this.markers[[index]] = point;
    }

    this.removeMarker = (index) => {
      if (this.markers[[index]])
        this.markers[index].setMap(null)

      this.markers[[index]] = undefined;
    }

    this.highlightMarker = (index) =>{
      this.removeMarker(index);

      if (this.state.stations[index]) {

        let coords = {
          lat: this.state.stations[index].lat,
          lng: this.state.stations[index].long
        }

        this.markers[[index]] = new google.maps.Marker({
          position: coords,
          map,
          icon: redtowericon
        })

        this.modifyState({default_center: coords})
      }
    }

    this.unhighlightMarker = (index) => {
      if (this.markers[[index]]) {
        this.markers[[index]].setMap(null)
        this.markers[[index]] = new google.maps.Marker({
          position: {
            lat: this.state.stations[index].lat,
            lng: this.state.stations[index].long
          },
          map,
          icon: blacktowericon,
        })
      }
    }

    let lats = [], longs = [];

    for (let [index, s] of this.state.stations.entries()){
      this.placeMarker(index, s.lat, s.long)
      lats.push(s.lat);
      longs.push(s.long);
    }

    for (let path of this.props.allPageStates.MapSelection.selectedNetworkAreas) { 
      let polygon = new google.maps.Polygon({
        paths: path,
        strokeColor: '#0050E6',
        strokeOpacity: 1,
        strokeWeight: 3,
        fillColor: '#0050E6',
        fillOpacity: 0.1,
        zIndex: 9999999,
        clickable: false
      });
      polygon.setMap(map);

      path.forEach(point => {
        lats.push(point.lat);
        longs.push(point.lng);
      });
    }

    // center/zoom the map to suit the user's network areas
    map.fitBounds({east: Math.max(...longs), north: Math.max(...lats), south: Math.min(...lats), west: Math.min(...longs)});
  }

  doesEachSiteHaveASector() {
    if (this.state.stations.length === 0)
      return false;

    let result = true;
    this.state.stations.forEach(s => {
      if (s.sectors.length === 0)
        result = false;
    });

    return result;
  }

  render() {
    var { previousPage } = this.props;

    return (
      <React.Fragment>
        <h3>Step 3: Plan your transmitter sites and equipment <em>for Ofcom OfW588 form, Sections C1-11</em></h3>

        <div className={'alert ' + (this.state.stations.length === 0 ? 'alert-primary' : 'alert-success')} role="alert">
          {this.state.stations.length === 0 ?
            'Where will your transmitter site(s) be located?' :
            'You have chosen your transmitter site(s)'}
        </div>

        <div className={'alert ' + (!this.doesEachSiteHaveASector() ? 'alert-primary' : 'alert-success')} role="alert">
          {!this.doesEachSiteHaveASector() ?
            'Which transmitter equipment will be mounted at your site(s)?' :
            'You have chosen transmitter equipment for each of your transmitter site(s)'}
        </div>

        <div className="row m-0">
          <div className="largecal">
            <button type="button" className="btn btn-primary small-add" disabled={false} onClick={()=>{
              const s = this.state.stations;

              s.push({
                "lat": '',
                "long": '',
                "eastings": '',
                "northings": '',
                "britgrid": '',
                "address": '',
                "address_components": [],
                "sectors": []
              });

              this.modifyState({stations: s});
              // need to delay this slightly so that the table has time to notice there is an extra row to expand
              setTimeout(() => {this.onExpandedChange({[s.length - 1]: {}})}, 100)
              this.onExpandedChange({[s.length - 1]: {}});
              this.exclusivelyExpandedRow = s.length - 1;
            }}>
              +
            </button>
            <ReactTable
              data={this.state.stations}
              columns={[
                {
                  Header: "Site Address",
                  accessor: "address"
                },
                {
                  Header: "Site Location",
                  id: "long",
                  accessor: d => `${d.lat}, ${d.long}`
                }
              ]}
              showPagination={false}
              defaultPageSize={10}
              expanded={this.state.expanded}
              onPageChange={pageIndex => {
                  this.onExpandedChange({});
              }}
              onPageSizeChange={(pageSize, pageIndex) => {
                  this.onExpandedChange({});
              }}
              onSortedChange={(newSorted, column, shiftKey) => {
                  this.onExpandedChange({});
              }}
              onFilteredChange={(filtered, column) => {
                  this.onExpandedChange({});
              }}
              onExpandedChange={(newExpanded, index, event) => {
                  if (this.exclusivelyExpandedRow===index[0]){
                      this.onExpandedChange({})
                      this.unhighlightMarker(index[0])
                      this.exclusivelyExpandedRow=null
                      return
                  } else if (this.exclusivelyExpandedRow !==null){
                      this.unhighlightMarker(this.exclusivelyExpandedRow)
                  }
                  newExpanded={}
                  newExpanded[index]={}
                  this.exclusivelyExpandedRow=index[0]
                  this.highlightMarker(index[0]);
                  this.onExpandedChange(newExpanded)
              }}

              className="-striped -highlight"
              getTrProps={(state, rowInfo, column, instance, expanded) => {
                  return {
                  onClick: e => {

                      // var rowIndex = "{'" + rowInfo.viewIndex + "':'true'}";
                      //this.setState({ expanded: {} });
                      //this.setState({ expanded: rowIndex });
                      //this.setState({ expanded: JSON.parse(rowIndex) });
                      //this.setState({expanded: "{'" + rowInfo.viewIndex + "':'true'}"});
                  }
                  };
              }}
              SubComponent={row => {
                return (
                  <div className={"pb-2"}>
                    <div className="container locationInputs">
                      <AddSiteForm SERVER_URLS={this.props.SERVER_URLS}
                                   existingStations={this.state.stations}
                                   stationIndex={row.index}
                                   submitAddStation={this.submitAddStation}
                                   removeStation={() => {
                                     this.removeMarker(row.index);
                                     this.exclusivelyExpandedRow = null;
                                     let tmp = this.state.stations;
                                     tmp.splice(row.index,1);
                                     this.setState({stations: tmp});
                                   }}
                                   selectedNetworkAreas={this.props.allPageStates.MapSelection.selectedNetworkAreas}
                                   map={this.state.map}
                                   onCancel={()=>{
                                     if (this.state.stations[row.index] && this.state.stations[row.index].lat === '') {
                                       // user created new station but cancelled before first submit, remove
                                       const s = this.state.stations;
                                       s.splice(row.index, 1);
                                       this.setState({stations: s})
                                     } else {
                                       // user cancelled edit of existing station
                                       this.exclusivelyExpandedRow = null;
                                       this.onExpandedChange({});
                                     }
                                   }}
                      />
                    </div>

                    <TransmitterTable data={row.original.sectors}
                                      siteIndex={row.index}
                                      remove={this.removeTransmitter}
                                      edit={this.editTransmitter}
                                      sortBy={this.sortBy}
                    />

                    <div className="button-row transmitter-inputs">
                      <button type="button"
                              className="btn btn-primary"
                              disabled={!this.state.stations[row.index] || this.state.stations[row.index].lat === ''}
                              onClick={()=>{
                                  this.currentTowerIndex = row.index
                                  this.currentTransmitterIndex = this.state.stations[this.currentTowerIndex].sectors.length > 0 ?
                                    this.state.stations[this.currentTowerIndex].sectors.length :
                                    0
                                  this.setState({showAddTransmitterModal: true})
                              }}>
                          Add Transmitter to Site
                      </button>
                    </div>

                  </div>
                );
              }}
            />
            <div className="button-row">
              <button type="button" className="btn btn-primary mr-0" disabled={false} onClick={()=>{
                const s = this.state.stations;

                s.push({
                  "lat": '',
                  "long": '',
                  "eastings": '',
                  "northings": '',
                  "britgrid": '',
                  "address": '',
                  "address_components": [],
                  "sectors": []
                });

                this.modifyState({stations: s});
                // need to delay this slightly so that the table has time to notice there is an extra row to expand
                setTimeout(() => {this.onExpandedChange({[s.length - 1]: {}})}, 100)
                this.onExpandedChange({[s.length - 1]: {}});
                this.exclusivelyExpandedRow = s.length - 1;
              }}>
                Add Site
              </button>
            </div>
          </div>

          <div className="smallcal">
            <div style={{ height: '41vh', width: '100%', margin: '0px' }}>
              <GoogleMapReact
                          bootstrapURLKeys={{key: localStorage.getItem("google_maps_api_key"), language: 'en'}}
                          center={this.state.default_center}
                          defaultZoom={10}
                          options={{gestureHandling:'greedy'}}
                          onGoogleApiLoaded={this.configureMap}
                          yesIWantToUseGoogleMapApiInternals/>
            </div>
          </div>
        </div>

        <div className="button-row">
          <button type="button" className="btn btn-light btn-lg" disabled={false} onClick={previousPage}>
              Previous Page
          </button>
          <button type="button" className="btn btn-light btn-lg" disabled={false} onClick={()=>{
                      this.props.saveAndExit()
                      }}>
                  Save and Exit
          </button>
          <button type="button" className="btn btn-primary btn-lg" disabled={this.state.stations.length<1|| !this.doesEachSiteHaveASector()} onClick={()=>{
            this.props.onSubmit()
          }}>Next Page</button>
        </div>

        <Modal show={this.state.showAddTransmitterModal} onHide={()=>this.setState({showAddTransmitterModal: false})} dialogClassName="modal-90w">
          <Modal.Header closeButton>
              <Modal.Title>Add transmitter</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <AddTransmitterForm
              selectedFrequencyRange={this.props.allPageStates.MapSelection.selected_freqs}
              antenna_specs={this.state.antenna_options}
              getInitialValues={this.addTransmitterFormInitialValues}
              onSubmit={(values)=> {
                const stations = this.state.stations
                values["eirp_dbm"] = values["eirp_dbw"] + 30
                const newSectorIndex = stations[this.currentTowerIndex].sectors.length>0 ?
                  Math.max.apply(Math, stations[this.currentTowerIndex].sectors.map(function(o) { return o.key; })) + 1
                  : 0;

                const indexMap = {
                  "id": newSectorIndex,
                  "key": newSectorIndex
                }

                const transmitter = {
                  ...indexMap,
                  ...(({ directional, nominal_gain_dbi, horizontal_beamwidth_deg, vertical_beamwidth_deg, lower_frequency_mhz, upper_frequency_mhz, lower_tilt_deg, upper_tilt_deg, make, model, polarisation, patterns }) => ({ directional, nominal_gain_dbi, horizontal_beamwidth_deg, vertical_beamwidth_deg, lower_frequency_mhz, upper_frequency_mhz, lower_tilt_deg, upper_tilt_deg, make, model, polarisation, patterns }))(this.state.antenna_options[values["antenna"]]),
                  ...{h_plot_svg:document.getElementById("horizontal-pattern-plot-svg-pdf").outerHTML, v_plot_svg:document.getElementById("vertical-pattern-plot-svg-pdf").outerHTML},
                  ...values
                };

                if (stations[this.currentTowerIndex].sectors.length === 0 || this.currentTransmitterIndex === stations[this.currentTowerIndex].sectors.length) {
                  // add
                  stations[this.currentTowerIndex].sectors.push(transmitter);
                } else {
                  // edit
                  stations[this.currentTowerIndex].sectors[this.currentTransmitterIndex] = transmitter;
                }

                this.setState({stations:stations, showAddTransmitterModal:false})
                this.currentTransmitterIndex = null;
              }}
              onCancel={()=>{this.setState({showAddTransmitterModal: false})}}
            />
          </Modal.Body>
        </Modal>
      </React.Fragment>
    )
  }
}
  
export default TransmittingStations
